module.exports = __webpack_public_path__ + "static/img/dd-target-icon-02.59730ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/dd-target-icon-02.png
// module id = dr29
// module chunks = 1